const swiper = new Swiper('.js-slider', {
    slidesPerView: 1,
    centeredSlides: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    spaceBetween: 20,
    slideToClickedSlide: true,
    breakpoints: {
        768: {
            slidesPerView: 2,
            centeredSlides: false,
        },
        1240: {
            slidesPerView: 3,
            centeredSlides: false,
        },
    }
})

const swiper2 = new Swiper('.js-slider-2', {
    slidesPerView: 1,
    centeredSlides: true,
    navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
    },
    spaceBetween: 20,
    slideToClickedSlide: false,
    // loop: true,
    // effect: 'fade',
    breakpoints: {
        768: {
            slidesPerView: 2,
            centeredSlides: false,
        },
        1240: {
            slidesPerView: 3,
            centeredSlides: false,
        },
    }
})
